import * as React from 'react';
import { PVACharacteristicGroupModal, PVACharacteristicModal } from '../inclinationmodals';
import { InclinationChart, InclinationMidrangeChart, PVAContainer, PVADiamond, DichotomyChart } from '../../components';
import { Style, CharacteristicCompare } from '../../models';
import './InclinationGroup.css';
import './GroupChart.css';
import { ReportType, InclinationType, MidRangeType } from '../../enums';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

interface InclinationTeamMidRange {
    teamID: number;
    midRangeLow: number;
    midRangeHigh: number;
}
interface Inclination {
    name: string;
    helpText: string;
    description: string;
    tooltip: string;
    inclinationType: InclinationType;
    value: number;
    midrangeLow: number;
    midrangeHigh: number;
    midrangeLowOrg: number;
    midrangeHighOrg: number;
    midrangeLowAll: number;
    midrangeHighAll: number;
    teamMidRanges: InclinationTeamMidRange[];
}

interface SubGroup {
    name: string;
    sort: number;
    data: Inclination[];
    about: string;
}

interface GroupData {
    name: string;
    subtitle: string;
    description: string;
    data: Inclination[];
    comparisons: CharacteristicCompare[];
    subGroups: SubGroup[];
}

interface GroupChartProps {
    groupData: GroupData;
    style?: Style;
    reportType: ReportType;
    midRangeType: MidRangeType;
    teamID: number;
    index: number;
    offset: number;
    headerOffset?: boolean;
    small?: boolean; // needed to resize midrange charts properly
    allowToggle: boolean;
}

interface GroupChartState {
    visible: boolean;
    modalVisible: boolean[];
    groupModal: boolean;
}

export class GroupChart extends React.Component<GroupChartProps, GroupChartState> {
    constructor(props: GroupChartProps) {
        super(props);

        this.state = {
            visible: false,
            modalVisible: [false],
            groupModal: false
        };
    }

    toggleModal(index: number) {
        if (index === -1) {
            this.setState({ groupModal: !this.state.groupModal });
            return;
        }

        let { modalVisible } = this.state;

        modalVisible[index] = !modalVisible[index];
        this.setState({ modalVisible: modalVisible });
    }

    getGroupModalElement(name: string, core: string, content: string) {
        const props = {
            show: this.state.groupModal,
            onHide: this.toggleModal.bind(this, -1),
            title: name,
            core: core,
            content: content,
            step: this.props.index,
            style: this.props.style
        };

        return (
            <div key={name}>
                <PVACharacteristicGroupModal {...props} />
            </div>);
    }

    getModalElement(inclinationType: string, name: string, content: string, index: number, value: number, desc: string, group: string, core: string) {
        const props = {
            show: this.state.modalVisible[index],
            onHide: this.toggleModal.bind(this, index),
            title: group,
            content: content,
            value: value,
            description: desc,
            core: core,
            step: this.props.index,
            name: name,
            allowToggle: this.props.allowToggle
        };
        
        return (
            <div key={name}>
                <PVACharacteristicModal {...props} />
            </div>);
    }    
    
    getSimpleModalElement(name: string, core: string, content: string, index: number) {
        const props = {
            show: this.state.modalVisible[index],
            onHide: this.toggleModal.bind(this, index),
            name: name,
            title: name,
            core: core,
            content: content,
            step: this.props.index,
            style: this.props.style
        };

        return (
            <div key={name}>
                <PVACharacteristicGroupModal {...props} />
            </div>);
    }

    private InclinationTable(groupName: string, groupSubtitle: string, data: Inclination[], modals: any[], areaName: string, offset: number) {
        const { reportType } = this.props;

        return (
            <div className="inclination-table">
                <div className="row">
                    <div className="col-xs-6 col-md-5 col-lg-4">
                        <div className="cell">
                            <span>{areaName}</span>
                        </div>
                        {
                            data.map((item, currIndex) => {
                                
                                modals.push(this.getModalElement(item.inclinationType.toString(), item.name, item.helpText, currIndex, item.value, item.description, groupName, groupSubtitle));

                                if (item.tooltip && item.tooltip.length > 0) {
                                const tooltip = <Tooltip id={`tooltip-${item.name}`}><span dangerouslySetInnerHTML={{ __html: item.tooltip }} /></Tooltip>;
                                return <OverlayTrigger key={`grid-cell-${currIndex}`} animation={''} delay={0} placement="top" overlay={tooltip}>
                                    <div className="cell text-left">
                                        <span className="characteristic-index">{offset + this.props.offset + currIndex + 1} </span>
                                        <span onClick={this.toggleModal.bind(this, currIndex)} className="characteristic-info glyphicon glyphicon-info-sign icon-button" />
                                        <span onClick={this.toggleModal.bind(this, currIndex)} className="characteristic-title">
                                                <b>{item.name}</b>
                                        </span>
                                    </div>
                                </OverlayTrigger>;
                                } else {
                                    return (
                                        <div key={`grid-cell-${currIndex}`} className="cell text-left">
                                            <span className="characteristic-index">{offset + this.props.offset + currIndex + 1} </span>
                                            <span onClick={this.toggleModal.bind(this, currIndex)} className="characteristic-info glyphicon glyphicon-info-sign icon-button" />
                                            <span onClick={this.toggleModal.bind(this, currIndex)} className="characteristic-title">
                                                    <b>{item.name}</b>
                                            </span>
                                        </div>
                                    );
                                }
                            })
                        }
                    </div>
                    <div className="col-xs-6 col-md-7 col-lg-8 scale-chart-wrapper">
                        <div className="bg" />
                        <div className="cell">
                            <div className="row">
                                <div className="col-xs-6 text-left">
                                    <div className="cell">
                                        <span className="chart-content" style={{ left: -5 }}>Less Pronounced</span>
                                    </div>
                                </div>
                                <div className="col-xs-6 text-right">
                                    <div className="cell">
                                        <span className="chart-content" style={{ right: 0 }}>More Pronounced</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {
                            data.map((item, currIndex) => {
                                let chart;
                                if (reportType === ReportType.Midrange) {
                                    var midrangeLow = item.midrangeLow;
                                    var midrangeHigh = item.midrangeHigh;
                                    switch (this.props.midRangeType) {
                                        case MidRangeType.Default: {
                                            break;
                                        }
                                        case MidRangeType.Team: {
                                            var mid = item.teamMidRanges.find((t: InclinationTeamMidRange) => {
                                                return t.teamID === this.props.teamID;
                                            });
                                            if (mid) {
                                                midrangeLow = mid.midRangeLow;
                                                midrangeHigh = mid.midRangeHigh;
                                            }
                                            break;
                                        }
                                        case MidRangeType.Organization: {
                                            midrangeLow = item.midrangeLowOrg;
                                            midrangeHigh = item.midrangeHighOrg;
                                            break;
                                        }
                                        case MidRangeType.All: {
                                            midrangeLow = item.midrangeLowAll;
                                            midrangeHigh = item.midrangeHighAll;
                                            break;
                                        }
                                        default: {
                                            break;
                                        }
                                    }
                                    chart = <InclinationMidrangeChart value={item.value} midrangeLow={midrangeLow} midrangeHigh={midrangeHigh} style={this.props.style ? this.props.style.name : ''} small={this.props.small} />;
                                } else {
                                    chart = <InclinationChart value={Math.round(item.value)} allowToggle={this.props.allowToggle} />;
                                }
                                return <div className="cell" key={`grid-chart-${currIndex}`}>
                                    {chart}
                                </div>;
                            })
                        }
                    </div>
                </div>
            </div>
        );
    }
    
    private InclinationTableWide(groupName: string, groupSubtitle: string, data: Inclination[], modals: any[], areaName: string, about: string, offset: number, modalIndex: number) {
        const { reportType } = this.props;

        modals.push(this.getSimpleModalElement(areaName, '', about, modalIndex));

        return (
            <div className="inclination-table wide">
                <div className="bg" />
                <div className="row">
                    <div className="col-xs-6 col-md-5 col-lg-4">
                        <div className="left-content">
                            <div className="cell">
                                <span onClick={this.toggleModal.bind(this, modalIndex)} className="characteristic-info glyphicon glyphicon-info-sign icon-button" />
                                <span>{areaName}</span>
                            </div>
                            {
                                data.map((item, ind) => {

                                    var currIndex = ind + offset + 1;
                                    var currModalIndex = ind + modalIndex + 1;
                                    
                                    modals.push(this.getModalElement(item.inclinationType.toString(), item.name, item.helpText, currModalIndex, item.value, item.description, groupName, groupSubtitle));

                                    if (item.tooltip && item.tooltip.length > 0) {
                                    const tooltip = <Tooltip id={`tooltip-${item.name}`}><span dangerouslySetInnerHTML={{ __html: item.tooltip }} /></Tooltip>;
                                    return <OverlayTrigger key={`grid-cell-${currIndex}`} animation={''} delay={0} placement="top" overlay={tooltip}>
                                        <div className="cell text-left">
                                            <span className="characteristic-index">{this.props.offset + currIndex} </span>
                                            <span onClick={this.toggleModal.bind(this, currModalIndex)} className="characteristic-info glyphicon glyphicon-info-sign icon-button" />
                                            <span onClick={this.toggleModal.bind(this, currModalIndex)} className="characteristic-title">
                                                    <b>{item.name}</b>
                                            </span>
                                        </div>
                                    </OverlayTrigger>;
                                    } else {
                                        return (
                                            <div key={`grid-cell-${currIndex}`} className="cell text-left">
                                                <span className="characteristic-index">{this.props.offset + currIndex} </span>
                                                <span onClick={this.toggleModal.bind(this, currModalIndex)} className="characteristic-info glyphicon glyphicon-info-sign icon-button" />
                                                <span onClick={this.toggleModal.bind(this, currModalIndex)} className="characteristic-title">
                                                        <b>{item.name}</b>
                                                </span>
                                            </div>
                                        );
                                    }
                                })
                            }
                        </div>
                    </div>
                    <div className="col-xs-6 col-md-7 col-lg-8 scale-chart-wrapper">
                        <div className="right-content">
                        <div className="cell">
                            <div className="row">
                                <div className="col-xs-6 text-left">
                                    <div className="cell">
                                        <span className="chart-content" style={{ left: -5 }}>Less Pronounced</span>
                                    </div>
                                </div>
                                <div className="col-xs-6 text-right">
                                    <div className="cell">
                                        <span className="chart-content" style={{ right: 0 }}>More Pronounced</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {
                            data.map((item, currIndex) => {
                                let chart;
                                if (reportType === ReportType.Midrange) {
                                    var midrangeLow = item.midrangeLow;
                                    var midrangeHigh = item.midrangeHigh;
                                    switch (this.props.midRangeType) {
                                        case MidRangeType.Default: {
                                            break;
                                        }
                                        case MidRangeType.Team: {
                                            var mid = item.teamMidRanges.find((t: InclinationTeamMidRange) => {
                                                return t.teamID === this.props.teamID;
                                            });
                                            if (mid) {
                                                midrangeLow = mid.midRangeLow;
                                                midrangeHigh = mid.midRangeHigh;
                                            }
                                            break;
                                        }
                                        case MidRangeType.Organization: {
                                            midrangeLow = item.midrangeLowOrg;
                                            midrangeHigh = item.midrangeHighOrg;
                                            break;
                                        }
                                        case MidRangeType.All: {
                                            midrangeLow = item.midrangeLowAll;
                                            midrangeHigh = item.midrangeHighAll;
                                            break;
                                        }
                                        default: {
                                            break;
                                        }
                                    }
                                    chart = <InclinationMidrangeChart value={item.value} midrangeLow={midrangeLow} midrangeHigh={midrangeHigh} style={this.props.style ? this.props.style.name : ''} small={this.props.small} />;
                                } else {
                                    chart = <InclinationChart value={Math.round(item.value)} allowToggle={this.props.allowToggle} />;
                                }
                                return <div className="cell" key={`grid-chart-${currIndex}`}>
                                    {chart}
                                </div>;
                            })
                        }
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const { groupData, index } = this.props;

        let modals: any[] = [this.getGroupModalElement(groupData.name, groupData.subtitle, groupData.description)];

        const icon = <PVADiamond onClick={this.toggleModal.bind(this, -1)} style={this.props.style ? this.props.style.name : ''} step={index + 1} />;
        //  index < 5 ? <img src={`/images/Diamond_${index + 1}of4.svg`} style={{ width: '40px' }} /> : <div />;

        const title = (
            <div onClick={this.toggleModal.bind(this, -1)}>
                <div className="title-sub">{groupData.subtitle}</div>
                <span> {groupData.name}
                    &nbsp;&nbsp;
                    <span className="glyphicon glyphicon-info-sign icon-button" />
                </span>
            </div>
        );

        const comparisonsContent = (
            <div className="dichotomy-container">
            { this.props.groupData.comparisons && this.props.groupData.comparisons.sort((a: any, b: any) => {
                    if (a.sort > b.sort) {
                        return 1;
                    } else if (a.sort < b.sort) {
                        return -1;
                    }
                    return 0;
                }).map((cc: any, ind: number) => {
                    var score: number = 0;
                    if (cc.characteristicCompareScoreType === 'thresholdGreater') {
                        if (cc.characteristicCompareScoreSide === 'left') {
                            // if left side is greater than threshold use left score
                            if (cc.characteristicLeftScore > cc.threshold) {
                                score = -cc.characteristicLeftScore;
                            } else {
                                if (cc.characteristicRightScore > cc.characteristicLeftScore) {
                                    score = cc.characteristicRightScore;
                                } else {
                                    score = -cc.characteristicLeftScore;
                                }
                            }
                        } else {
                            // if right side is greater than threshold use left score
                            if (cc.characteristicRightScore > cc.threshold) {
                                score = cc.characteristicRightScore;
                            } else {
                                if (cc.characteristicRightScore > cc.characteristicLeftScore) {
                                    score = cc.characteristicRightScore;
                                } else {
                                    score = -cc.characteristicLeftScore;
                                }
                            }
                        }
                    } else if (cc.characteristicCompareScoreType === 'thresholdLessThan') {
                        if (cc.characteristicCompareScoreSide === 'left') {
                            // if left side is greater than threshold use left score
                            if (cc.characteristicLeftScore < cc.threshold) {
                                score = -cc.characteristicLeftScore;
                            } else {
                                score = cc.characteristicRightScore;
                            }
                        } else {
                            // if right side is greater than threshold use left score
                            if (cc.characteristicRightScore < cc.threshold) {
                                score = cc.characteristicRightScore;
                            } else {
                                score = -cc.characteristicLeftScore;
                            }
                        }
                    } else 
                    if (cc.characteristicCompareScoreType === 'forceGreater') {
                        if (cc.characteristicCompareScoreSide === 'left') {
                            // if left side is greater than threshold use left score
                            if (cc.characteristicLeftScore > cc.threshold) {
                                score = -cc.characteristicLeftScore;
                            } else {
                                score = cc.characteristicRightScore;
                            }
                        } else {
                            // if right side is greater than threshold use left score
                            if (cc.characteristicRightScore > cc.threshold) {
                                score = cc.characteristicRightScore;
                            } else {
                                score = -cc.characteristicLeftScore;
                            }
                        }
                    } else if (cc.characteristicCompareScoreType === 'forceLessThan') {
                        if (cc.characteristicCompareScoreSide === 'left') {
                            // if left side is greater than threshold use left score
                            if (cc.characteristicLeftScore < cc.threshold) {
                                score = -cc.characteristicLeftScore;
                            } else {
                                score = cc.characteristicRightScore;
                            }
                        } else {
                            // if right side is greater than threshold use left score
                            if (cc.characteristicRightScore < cc.threshold) {
                                score = cc.characteristicRightScore;
                            } else {
                                score = -cc.characteristicLeftScore;
                            }
                        }
                    } else {
                        score = cc.characteristicLeftScore > cc.characteristicRightScore ?  -cc.characteristicLeftScore : cc.characteristicRightScore;
                    }

                    return <div key={`cc-${ind}`} className="dichotomy-row">
                        <div className="row">
                            <div className="col-xs-3 text-right dichotomy-content">
                                <div dangerouslySetInnerHTML={{__html: cc.left}} />
                            </div>
                            <div className="col-xs-6 text-center">
                                <div className="dichotomy-title">
                                    <div className="dichotomy-left">
                                        PRONOUNCED
                                    </div>
                                    <div className="dichotomy-center">
                                        {cc.name}
                                    </div>
                                    <div className="dichotomy-right">
                                        PRONOUNCED
                                    </div>
                                </div>
                                <div>
                                    <DichotomyChart value={score} style={(this.props.style  && this.props.style.name) ? this.props.style.name : undefined} />
                                </div>
                            </div>
                            <div className="col-xs-3 text-left dichotomy-content">
                                <div dangerouslySetInnerHTML={{__html: cc.right}} />
                            </div>
                        </div>
                    </div>;
                })
            }
        </div>);

        var offset = groupData.data.length;
        var modalIndex = offset;

        const content = (
            <div>
                <div>
                    {groupData.data.length > 0 && this.InclinationTable(groupData.name, groupData.subtitle, groupData.data, modals, '', 0)}
                    {groupData.subGroups.sort((sg1: any, sg2: any) => {
                        if (sg1.sort > sg2.sort) {
                            return 1;
                        }
                        if (sg1.sort < sg2.sort) {
                            return -1;
                        }
                        return 0;
                    }).map((sg: SubGroup, sbInd: number) => {
                        var off = offset;
                        offset += sg.data.length;
                        modalIndex += sg.data.length + 1;

                        return <div key={`sub-group-${sbInd}`}>
                            {this.InclinationTableWide(groupData.name, groupData.subtitle, sg.data, modals, sg.name, sg.about, off, modalIndex)}
                        </div>;
                    })}
                </div>

                {this.props.groupData.comparisons && this.props.groupData.comparisons.length > 0 && comparisonsContent}

                {modals}
            </div>
        );

        return <PVAContainer icon={icon} title={title} content={content} id={groupData.name} offset={this.props.headerOffset} />;
    }
}


// WEBPACK FOOTER //
// ./src/components/charts/GroupChart.tsx